import React from 'react';
import getConfig from 'next/config';
import { NextSeo, SiteLinksSearchBoxJsonLd } from 'next-seo';
import BasicLayout from 'layout/Basic';
import { convertProps } from 'lib/parseAPIResponse';
import createFromObject from 'lib/queryString';
import CompanyIndex, { Props } from 'containers/Companies/List';

export const Companies = (props: Props) => {
    const { url, name } = getConfig().publicRuntimeConfig;
    return (
        <BasicLayout ads={props.ads}>
            <NextSeo title={`Firmy | ${name}`} />
            <SiteLinksSearchBoxJsonLd
                url={url}
                potentialActions={[
                    {
                        target: `${url}/katalog-firm?letter`,
                        queryInput: 'letter'
                    },
                    {
                        target: `${url}/katalog-firm?branch`,
                        queryInput: 'branch'
                    },
                    {
                        target: `${url}/katalog-firm?name`,
                        queryInput: 'name'
                    }
                ]}
            />
            <CompanyIndex {...props} />
        </BasicLayout>
    );
};

export async function getServerSideProps({ query }) {
    const { apiUrl } = getConfig().publicRuntimeConfig;

    const url = `${apiUrl}/public/api/companies${createFromObject(query)}`;
    return Promise.all([
        fetch(url),
        fetch(`${apiUrl}/public/api/naszadsik?path=katalog-firm`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();

        return {
            props: {
                ...convertProps(ads),
                ...convertProps(data)
            }
        };
    });
}

export default Companies;
